import React, { Component } from 'react';
import newBanner from './Image/newBanner.jpg'
export default function Banner() {
    return (
       <img src={newBanner} className="w-full hidden lg:block lg:h-screen" alt=""/>
    )
}
